<div style="position: fixed;
top: 0;
left: 0px;
width: 100%;z-index:100; box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);">
  <div nz-row [nzGutter]="16" class="WebView" style="background: rgb(255, 255, 255);
  margin: 0px -8px;
  height: 100px;
  padding: 10px 0px;">
    <div nz-col [nzXs]="{ span: 20,offset: 2}" [nzSm]="{ span: 22,offset: 1}" [nzMd]="{ span: 22,offset: 1}"
      [nzLg]="{ span: 22,offset: 1}">
      <div nz-row [nzGutter]="16">
        <div nz-col [nzXs]="{ span: 4}" [nzSm]="{ span: 2}" [nzMd]="{ span: 2}" [nzLg]="{ span: 3}"
          style="cursor: pointer;" (click)="OnClickHome()">
          <img src="/assets/images/new/login-icon.png" style="width: 88px;height: 73px;" />
        </div>
        <div nz-col [nzXs]="{ span: 14}" [nzSm]="{ span:  12}" [nzMd]="{ span: 12}" [nzLg]="{ span: 13}">
          <div nz-row>

            <div class="warehouse" style="display: flex ; gap: 0.5rem;align-items:center ;width: 100%;">
              <!-- <ng-template #suffixButton>
                <button nz-button nzType="primary" class="pincode-button" nzSize="large" nzSearch
                  (click)="onClickLoaction()">{{cityName | slice:0:16}}
                  <span *ngIf="cityName.length>16">...</span> 
                  <i nz-icon nzType="caret-down" nzTheme="outline"
                    style="margin-left: 10px;"></i></button>
              </ng-template> -->
              <nz-form-item style="margin-bottom: 0;border: 1px solid #ccc;border-radius:5px; ">
                <nz-form-control>
                  <nz-select nzPlaceHolder="Select Warehouse" style="font-weight: 500;min-width: 5rem;"
                    [formControl]="selectedwarehouse">

                    <nz-option style="min-width: 8rem;" *ngFor="let type of warehouseList" [nzValue]="type.warehouseId"
                      [nzLabel]="type.warehouseName "></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
              <nz-input-group nzSearch style="flex: 2;">
                <input placeholder="Please Search by Molecule/Salt Name" style="margin-top: 2px;
                border-radius: 6px;" nz-input [(ngModel)]="search_value" (input)="onInput($event,'')"
                  [nzAutocomplete]="auto" />
                <nz-autocomplete #auto>
                  <nz-auto-option *ngIf="ProductListData.length >=0" style="font-weight: 600;">Showing generic
                    equivalents for branded medicines</nz-auto-option>
                  <div nz-row>
                    <div style="padding-left: 50px;" nz-col nzSpan="12">
                      <input [(ngModel)]="searchMode" (click)="listProducts()" id="radio" type="radio" value="1">
                      <label for="radio">Molecule</label>
                    </div>
                    <div nz-col nzSpan="12">
                      <input [(ngModel)]="searchMode" (click)="listBrands()" id="radio" type="radio" value="2">
                      <label for="radio">Brand</label>
                    </div>
                  </div>
                  <div *ngIf="searchMode =='1'">
                    <ng-container *ngFor="let product of ProductListData">
                      <div nz-row>
                        <div nz-col [nzXs]="{ span: 2}" [nzSm]="{ span: 2}" [nzMd]="{ span: 2}" [nzLg]="{ span: 2}"
                          style="text-align: center;">
                          <img [src]="product.imageUrl?product.imageUrl:default_Image"
                            style="width: 80%;margin-top: 10px;height: 40px;" />
                        </div>
                        <div nz-col [nzXs]="{ span: 14}" [nzSm]="{ span: 14}" [nzMd]="{ span: 14}" [nzLg]="{ span: 14}">
                          <nz-auto-option (click)="onSelectedProduct(product)"
                            [nzValue]="product.productName">{{product.productName}}<br />
                            <span style="font-size: 10px;">{{product.genericName}}</span></nz-auto-option>
                        </div>
                        <div nz-col [nzXs]="{ span: 4}" [nzSm]="{ span: 4}" [nzMd]="{ span: 4}" [nzLg]="{ span: 4}">
                          <nz-auto-option [nzValue]="product.medbuzz_sellingPrice" style="margin-top: 9px;"><span>Rs
                              {{product.medbuzz_sellingPrice}}</span><br />
                          </nz-auto-option>
                        </div>
                        <div nz-col [nzXs]="{ span: 4}" [nzSm]="{ span: 4}" [nzMd]="{ span: 4}" [nzLg]="{ span: 4}">
                          <button class="addtoCart" *ngIf="product.Stock_Available" (click)="onViewCart(product)">Add To
                            Cart</button>
                          <button class="addtoCart" *ngIf="!product.Stock_Available"
                            (click)="onproductNotify(product)">Notify Me</button>
                        </div>
                      </div>

                    </ng-container>
                    <nz-auto-option *ngIf="ProductListData.length ==0&&!isProductLoading&&!isLoading">No
                      Data</nz-auto-option>
                  </div>
                  <div *ngIf="searchMode =='2'&&!brandProducts">
                    <ng-container *ngFor="let brand of compositionListData">
                      <div nz-row>
                        <div nz-col [nzXs]="{ span: 20}" [nzSm]="{ span: 20}" [nzMd]="{ span: 20}" [nzLg]="{ span: 20}">
                          <nz-auto-option (click)="onSelectedProduct(brand)"
                            [nzValue]="brand.mgProductName">{{brand.mgProductName}}<br />
                            <span style="font-size: 10px;">{{brand.mgComposition}}</span><br />
                            <span style="font-size: 10px;">{{brand.mgCompanyName}}</span></nz-auto-option>
                        </div>
                        <div nz-col [nzXs]="{ span: 4}" [nzSm]="{ span: 4}" [nzMd]="{ span: 4}" [nzLg]="{ span: 4}">
                          <button class="addtoCart" (click)="onBrandSelect(brand)">Convert</button>
                        </div>
                      </div>

                    </ng-container>
                    <nz-auto-option *ngIf="compositionListData.length ==0&&!isMoleculeLoading&&!isLoading">No
                      Data</nz-auto-option>
                  </div>
                  <div *ngIf="brandProducts&&searchMode =='2'">
                    <ng-container *ngFor="let product of brandProductsList">
                      <div nz-row>
                        <div nz-col [nzXs]="{ span: 2}" [nzSm]="{ span: 2}" [nzMd]="{ span: 2}" [nzLg]="{ span: 2}"
                          style="text-align: center;">
                          <img [src]="product.imageUrl?product.imageUrl:default_Image"
                            style="width: 80%;margin-top: 10px;height: 40px;" />
                        </div>
                        <div nz-col [nzXs]="{ span: 14}" [nzSm]="{ span: 14}" [nzMd]="{ span: 14}" [nzLg]="{ span: 14}">
                          <nz-auto-option (click)="onSelectedProduct(product)"
                            [nzValue]="product.productName">{{product.productName}}<br />
                            <span style="font-size: 10px;">{{product.genericName}}</span></nz-auto-option>
                        </div>
                        <div nz-col [nzXs]="{ span: 4}" [nzSm]="{ span: 4}" [nzMd]="{ span: 4}" [nzLg]="{ span: 4}">
                          <nz-auto-option [nzValue]="product.medbuzz_sellingPrice" style="margin-top: 9px;"><span>Rs
                              {{product.medbuzz_sellingPrice}}</span><br />
                          </nz-auto-option>
                        </div>
                        <div nz-col [nzXs]="{ span: 4}" [nzSm]="{ span: 4}" [nzMd]="{ span: 4}" [nzLg]="{ span: 4}">
                          <button class="addtoCart" *ngIf="product.Stock_Available" (click)="onViewCart(product)">Add To
                            Cart</button>
                          <button class="addtoCart" *ngIf="!product.Stock_Available"
                            (click)="onproductNotify(product)">Notify Me</button>
                        </div>
                      </div>

                    </ng-container>
                    <nz-auto-option *ngIf="brandProductsList.length ==0&&!isProductLoading&&!isLoading">No Products in
                      selected brand</nz-auto-option>
                  </div>
                </nz-autocomplete>
              </nz-input-group>
            </div>
            <div nz-col [nzXs]="{ span: 24}" [nzSm]="{ span: 24}" [nzMd]="{ span: 24}" [nzLg]="{ span: 20}">
              <div nz-row style="margin: 6px 0px 0px 5px;">
                <div nz-col [nzXs]="{ span: 6}" [nzSm]="{ span: 4}" [nzMd]="{ span: 4}" [nzLg]="{ span: 4}">
                  <p class="menu" (click)="OnClickHome()">Home</p>
                </div>
                <div nz-col [nzXs]="{ span: 6}" [nzSm]="{ span: 5}" [nzMd]="{ span: 5}" [nzLg]="{ span: 5}">
                  <p class="menu" routerLink="/about-us">About Us</p>
                </div>
                <div nz-col [nzXs]="{ span: 6}" [nzSm]="{ span: 5}" [nzMd]="{ span: 5}" [nzLg]="{ span: 5}">
                  <p class="menu" routerLink="/contact-us">Contact Us</p>
                </div>
                <div nz-col [nzXs]="{ span: 6}" [nzSm]="{ span: 5}" [nzMd]="{ span: 5}" [nzLg]="{ span: 4}">
                  <p class="menu" routerLink="/blog">Blog</p>
                </div>

              </div>
            </div>
          </div>

        </div>
        <div nz-col [nzXs]="{ span: 5}" [nzSm]="{ span: 2}" [nzMd]="{ span: 2}" [nzLg]="{ span: 2}"
          style="text-align: center;margin-top: 4px;">
          <div (click)="onNavigateToCart()">
            <img src="/assets/images/new/cart-icon.svg" style="width: 36px;height: 34px;" />
            <span *ngIf="cartItemsCount>0"><nz-badge [nzStyle]="{ backgroundColor: '#006493' }" nzShowZero
                [nzCount]="cartItemsCount"></nz-badge></span>
          </div>
        </div>
        <div nz-col [nzXs]="{ span: 5}" [nzSm]="{ span: 1}" [nzMd]="{ span: 1}" [nzLg]="{ span: 1}"
          style="margin-top: 8px;">
          <img src="/assets/images/new/user-icon.svg" style="width: 30px;height: 30px;" />
        </div>
        <div nz-col [nzXs]="{ span: 5}" [nzSm]="{ span: 5}" [nzMd]="{ span: 5}" [nzLg]="{ span: 5}"
          style="margin-top: 4px;">
          <p *ngIf="isuserLoged==false"><span class="Login-Signup" (click)="onMobileLogin(1)">Login</span><span
              class="Login-Signup"> / Signup</span></p>
          <div *ngIf="isuserLoged">
            <p class="user-text">
              <a nz-dropdown [nzDropdownMenu]="menu" class="userMouseOver" style="color: #19baba;">{{userName |
                slice:0:18}} <span *ngIf="userName?.length>18">...</span> <i nz-icon nzType="caret-down"
                  nzTheme="outline"></i></a>
            </p>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu nzSelectable style="width: 100%;padding: 15px 0px;">
                <li nz-menu-item style="color: #000;" routerLink="/user-profile/my-orders">My Orders</li>
                <li nz-menu-item style="color: #000;" routerLink="user-profile/add-address">Manage Address</li>
                <li nz-menu-item style="color: #000;" routerLink="/user-profile/Profile">Profile</li>
                <li nz-menu-item style="color: #000;" routerLink="/user-profile/Wallet">Wallet</li>
                <li nz-menu-item style="color: #000;" routerLink="/user-profile/Wishlist">Wishlist</li>
                <li nz-menu-item style="color: #000;" routerLink="/user-profile/Saved-Prescription">Prescriptions</li>


                <li nz-menu-item style="color: #000;" routerLink="/user-profile/req-availability">Req Availability</li>
                <li nz-menu-item style="color: #000;" routerLink="/request-call">Request Call Back</li>
                <li nz-menu-item style="color: #000;" routerLink="/user-profile/Saved-Prescription">Saved
                  Prescription</li>
                <li nz-menu-item style="color: #000;" routerLink="/FAQs">FAQs</li>
                <li nz-menu-item style="color: #000;" routerLink="/Health-Articals">Health Articles</li>
                <li nz-menu-item style="color: #000;" routerLink="/Contact-us">Help Center</li>
                <li nz-menu-item style="color: #000;" routerLink="/about-us">About US</li>
                <li nz-menu-item style="color: #000;" routerLink="/terms-conditions">Terms of use</li>
                <li nz-menu-item style="color: #000;" routerLink="/privacy-policy">Privacy Policy</li>
                <li nz-menu-item style="color: #000;" (click)="Loguot()">Logout</li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </div>





        <!-- <div nz-col [nzXs]="{ span: 5}"  [nzSm]="{ span: 8}" [nzMd]="{ span: 8}"  [nzLg]="{ span: 5}">
          <div nz-row>
            <div nz-col [nzXs]="{ span: 24}"  [nzSm]="{ span: 24}" [nzMd]="{ span: 24}"  [nzLg]="{ span: 24}">
              <a href="tel:8886660207" style="color: #000;"><button nz-button nzType="primary" class="pincode-button" style="width: 100%;text-align: center;">
                <i nz-icon nzType="phone" nzTheme="outline"></i> Need Help</button></a>
            </div>
            <div nz-col [nzXs]="{ span: 24}"  [nzSm]="{ span: 24}" [nzMd]="{ span: 24}"  [nzLg]="{ span: 24}">
              <div nz-row style="margin-top: 6px;">
                <div nz-col [nzXs]="{ span: 15}"  [nzSm]="{ span: 15}" [nzMd]="{ span: 15}" [nzLg]="{ span: 15}">
                  <div *ngIf="isuserLoged">
                    <p class="user-text"><i nz-icon nzType="user" nzTheme="outline"
                        style="color: #fff;margin-right: 10px;"></i>
                      <a nz-dropdown [nzDropdownMenu]="menu" class="userMouseOver"><span style="color: #fff;">{{userName?userName:'New User'}}</span></a>
                    </p>
                    <nz-dropdown-menu #menu="nzDropdownMenu">
                      <ul nz-menu nzSelectable style="width: 100%;padding: 15px 0px;">
                        <li nz-menu-item style="color: #000;" routerLink="/user-profile/my-orders">My Orders</li>
                        <li nz-menu-item style="color: #000;" routerLink="user-profile/add-address">Manage Address</li>
                        <li nz-menu-item style="color: #000;" routerLink="/user-profile/Profile">Profile</li>
                        <li nz-menu-item style="color: #000;" routerLink="/user-profile/req-availability">Req Availability</li>
                        <li nz-menu-item style="color: #000;" routerLink="/user-profile/callBack-availability">Callback Availability</li>
                        <li nz-menu-item style="color: #000;" routerLink="/user-profile/Saved-Prescription">Saved
                          Prescription</li>
                        <li nz-menu-item style="color: #000;" routerLink="/user-profile/FAQs">FAQs</li>
                        <li nz-menu-item style="color: #000;" routerLink="/Health-Articals">Health Articles
                        </li>
                        <li nz-menu-item style="color: #000;" routerLink="/user-profile/About-Us">About US</li>
                        <li nz-menu-item style="color: #000;" routerLink="/Terms-Conditions">Terms of use</li>
                        <li nz-menu-item style="color: #000;" routerLink="/Privacy-Policy">Privacy Policy</li>
                        <li nz-menu-item style="color: #000;" (click)="Loguot()">Logout</li>
                      </ul>
                    </nz-dropdown-menu>
                  </div>
                  <p class="Cart-title" *ngIf="isuserLoged==false"><i nz-icon nzType="user" nzTheme="outline"
                      style="margin-right: 5px;"></i> <span (click)="onMobileLogin(1)">Login</span> /
                    <span>Signup</span></p>
                </div>
                <div nz-col [nzXs]="{ span: 9}"  [nzSm]="{ span: 9}" [nzMd]="{ span: 9}"  [nzLg]="{ span: 9}">
                  <p class="Cart-title" (click)="onNavigateToCart()"><img src="/assets/images/cart-icon.svg" style="width: 20px;" /> Cart
                    <span *ngIf="cartItemsCount>0">-<nz-badge [nzStyle]="{ backgroundColor: '#006493' }" nzShowZero [nzCount]="cartItemsCount"></nz-badge></span></p>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>

  <div nz-row class="mobileView" style="background: #fff;margin: 0px;" *ngIf="isBottomNavbarShoning">
    <div nz-col [nzXs]="{ span: 24}" [nzSm]="{ span: 24}" [nzMd]="{ span: 24}" [nzLg]="{ span: 24}">
      <div nz-row>
        <div nz-col [nzXs]="{ span: 2}" [nzSm]="{ span: 1}" [nzMd]="{ span: 1}" [nzLg]="{ span: 1}">
          <img src="/assets/images/new/more.svg" style="width: 100%;margin-top: 7px;margin-left: 10px;"
            (click)="onMobileLogin(2)" />
        </div>
        <div nz-col [nzXs]="{ span: 10, offset:1}" [nzSm]="{span: 8, offset:1}" [nzMd]="{ span: 8, offset:1}"
          [nzLg]="{ span: 8, offset:1}">
          <div nz-row [nzGutter]="16" (click)="OnClickHome()" style="margin-bottom: 4px;">
            <div nz-col [nzXs]="{ span:24}" [nzSm]="{ span: 4}" [nzMd]="{ span: 4}" [nzLg]="{ span: 4}"
              style="text-align: center;">
              <img src="/assets/images/new/login-mobi.png" alt="images" class="location-size" />
            </div>
            <!-- <div nz-col [nzXs]="{ span: 18}" [nzSm]="{ span: 18}" [nzMd]="{ span: 18}"   [nzLg]="{ span: 18}" style="margin-top: 12px;">
              <p class="location-text" style="color: #fff;margin-top: 2px;">{{cityName}}</p>
            </div> -->
          </div>
        </div>
        <div nz-col [nzXs]="{ span: 2, offset:4}" [nzSm]="{span: 8, offset:1}" [nzMd]="{ span: 8, offset:1}"
          [nzLg]="{ span: 3, offset:3}">
          <img src="/assets/images/new/user-icon.svg" style="width: 35px;height: 35px;margin-top: 7px;"
            *ngIf="isuserLoged==false" (click)="onclicksignup(1)" />

          <img src="/assets/images/new/user-icon.svg" style="width: 35px;height: 35px;margin-top: 7px;"
            *ngIf="isuserLoged==true" (click)="selsetedProfile(3)" />
        </div>
        <div nz-col [nzXs]="{ span: 4, offset:1}" [nzSm]="{ span: 1, offset:1}" [nzMd]="{ span: 1, offset:1}"
          [nzLg]="{ span: 1, offset:1}">
          <div (click)="onNavigateToCart()">
            <span class="mobile-padding"><nz-badge [nzStyle]="{ backgroundColor: '#006493' }" nzShowZero
                [nzCount]="cartItemsCount">
                <img src="/assets/images/new/cart-mobi.svg" class="mobile-padding" />
              </nz-badge></span>
          </div>

        </div>

      </div>
      <div nz-row>
        <div nz-col nzSpan="24" style="margin-bottom: 5px;padding: 0px 10px;">
          <nz-input-group nzSearch [nzPrefix]="prefixIconSearch">

            <input placeholder="Search for Products" nz-input [(ngModel)]="search_value"
              (input)="onInput($event,'mobile')" [nzAutocomplete]="auto" />
            <nz-autocomplete #auto>
              <nz-auto-option *ngIf="ProductListData.length >=0" style="font-weight: 600;">Showing generic equivalents
                for branded medicines</nz-auto-option>
              <ng-container *ngFor="let product of ProductListData">

                <div nz-row>
                  <div nz-col [nzXs]="{ span: 2}" [nzSm]="{ span: 2}" [nzMd]="{ span: 2}" [nzLg]="{ span: 2}"
                    style="text-align: center;">
                    <img [src]="product?.imageUrl" style="width: 70%;margin-top: 10px;height: 30px;" />
                  </div>
                  <div nz-col [nzXs]="{ span: 12}" [nzSm]="{ span: 16}" [nzMd]="{ span: 16}" [nzLg]="{ span: 16}">
                    <nz-auto-option (click)="onSelectedProduct(product)"
                      [nzValue]="product.productName">{{product.productName}}<br />
                      <span style="font-size: 10px;">{{product.genericName}}</span></nz-auto-option>
                  </div>
                  <div nz-col [nzXs]="{ span: 5}" [nzSm]="{ span: 4}" [nzMd]="{ span: 4}" [nzLg]="{ span: 4}">
                    <nz-auto-option [nzValue]="product.medbuzz_sellingPrice" style="margin-top: 9px;"><span>Rs
                        {{product.medbuzz_sellingPrice}}</span><br />
                    </nz-auto-option>
                  </div>
                  <div nz-col [nzXs]="{ span: 5}" [nzSm]="{ span: 4}" [nzMd]="{ span: 4}" [nzLg]="{ span: 4}">
                    <button class="addtoCart" *ngIf="product.Stock_Available" (click)="onViewCart(product)">Add To
                      Cart</button>
                    <button class="addtoCart" *ngIf="!product.Stock_Available" (click)="onproductNotify(product)">Notify
                      Me</button>
                  </div>
                </div>

              </ng-container>
              <nz-auto-option *ngIf="ProductListData.length ==0&&!isProductLoading&&isLoading">No Data</nz-auto-option>
            </nz-autocomplete>
          </nz-input-group>
          <ng-template #prefixIconSearch>
            <i nz-icon nzType="search"></i>
          </ng-template>
        </div>
      </div>
      <!-- <div nz-row style="margin-top: 10px;">
        <div nz-col  [nzXs]="{ span: 6,offset: 1}"  [nzSm]="{ span: 6,offset: 1}" [nzMd]="{ span: 12}"  [nzLg]="{ span: 4}">
            <p style="margin-bottom: 0px;color: #777;font-size: 16px;">Deliver to</p>
        </div>
        <div nz-col [nzXs]="{ span: 16}"  [nzSm]="{ span: 12}" [nzMd]="{ span: 12}"  [nzLg]="{ span: 4}" style="margin-bottom: 5px;padding: 0px 10px;">
          <p style="color: #19baba;margin-bottom: 10px;">{{cityName}} <i nz-icon nzType="down" nzTheme="outline"></i></p>
          </div>
          </div> -->

    </div>
  </div>
</div>
<div nz-row class="main-height">
  <div nz-col nzSpan="24">
    <router-outlet></router-outlet>
  </div>
</div>


<nz-drawer [nzVisible]="LoginVisible" [nzWidth]="350" [nzClosable]="true" [nzPlacement]="'left'"
  (nzOnClose)="Loginclose()" [nzTitle]="title">
  <ng-template #title>
    <p class="Home-text" style="color: #fff;font-size: 27px;padding: 20px 0px 0px;"><i nz-icon nzType="menu-unfold"
        nzTheme="outline"></i> Menu</p>
  </ng-template>
  <div nz-row>
    <div nz-col [nzSpan]="24">
      <div nz-row style="border-bottom: 1px solid #ddd;" *ngIf="isuserLoged">
        <div nz-col [nzXs]="{ span: 24}" [nzSm]="{ span: 24}" [nzMd]="{ span: 24}" [nzLg]="{ span: 24}">
          <div nz-row [nzGutter]="8" style="margin-bottom: 15px;">
            <div nz-col [nzXs]="{ span: 6}" [nzSm]="{ span: 6}" [nzMd]="{ span: 6}" [nzLg]="{ span: 6}">
              <nz-avatar [nzSize]="64" nzIcon="user" [nzSrc]="image"></nz-avatar>
            </div>
            <div nz-col [nzXs]="{ span: 12}" [nzSm]="{ span: 12}" [nzMd]="{ span: 12}" [nzLg]="{ span: 12}">
              <p style="font-size: 16px;
                font-weight: bold;margin-top: 7px;
                color: #000;">{{userName}}<br /> {{userNumber}}</p>
            </div>
          </div>
        </div>
      </div>

      <div style="margin-top: 15px;">
        <p class="Home-text"><span (click)="OnClickHome()"><i nz-icon nzType="home" nzTheme="outline"
              style="margin-right: 10px;"></i> Home</span></p>

        <p *ngIf="!isuserLoged" class="Home-text"><span (click)="onclicksignup(1)"><i nz-icon nzType="login"
              nzTheme="outline" style="margin-right: 10px;"></i> Login</span></p>
        <p *ngIf="!isuserLoged" class="Home-text"> <span (click)="onclicksignup(2)"><i nz-icon nzType="user"
              nzTheme="outline" style="margin-right: 10px;"></i> Signup</span></p>
      </div>
      <div style="border-top: 1px solid #ddd;" *ngIf="isuserLoged">
        <p class="Home-text" style="margin-top: 15px;" (click)="selsetedProfile(1)">
          <i nz-icon nzType="book" nzTheme="outline" style="margin-right: 10px;"></i> My Orders
        </p>
        <p class="Home-text" (click)="selsetedProfile(2)">
          <i nz-icon nzType="heat-map" nzTheme="outline" style="margin-right: 10px;"></i> My Address
        </p>
        <p class="Home-text" (click)="selsetedProfile(3)" style="margin-top: 10px;">
          <i nz-icon nzType="profile" nzTheme="outline" style="margin-right: 10px;"></i> Profile
        </p>
        <p class="Home-text" (click)="selsetedProfile(16)" style="margin-top: 10px;">
          <i nz-icon nzType="profile" nzTheme="outline" style="margin-right: 10px;"></i> Wallet
        </p>
        <p class="Home-text" (click)="selsetedProfile(17)" style="margin-top: 10px;">
          <i nz-icon nzType="profile" nzTheme="outline" style="margin-right: 10px;"></i> Wishlist
        </p>

        <p class="Home-text" (click)="selsetedProfile(13)" style="margin-top: 10px;">
          <i nz-icon nzType="profile" nzTheme="outline" style="margin-right: 10px;"></i> Req Availability
        </p>
        <p class="Home-text" (click)="selsetedProfile(14)" style="margin-top: 10px;">
          <i nz-icon nzType="profile" nzTheme="outline" style="margin-right: 10px;"></i> Callback Availability
        </p>
        <p class="Home-text" (click)="selsetedProfile(4)">
          <i nz-icon nzType="windows" nzTheme="outline" style="margin-right: 10px;"></i> Saved Prescription
        </p>

      </div>
      <div style="border-top: 1px solid #ddd;">
        <p class="Home-text" (click)="selsetedProfile(7)" style="margin-top: 10px;"> FAQs
        </p>
        <p class="Home-text" (click)="selsetedProfile(8)" style="margin-top: 10px;">Health Articles
        </p>
        <p class="Home-text" style="margin-top: 10px;" (click)="selsetedProfile(9)">About US
        </p>
        <p class="Home-text" style="margin-top: 10px;" (click)="selsetedProfile(15)">Contact Us
        </p>
        <p class="Home-text" style="margin-top: 10px;" (click)="selsetedProfile(10)">Terms & Conditions
        </p>
        <p class="Home-text" style="margin-top: 10px;" (click)="selsetedProfile(11)">Privacy & Policy
        </p>
      </div>
      <div *ngIf="isuserLoged" style="border-top: 1px solid #ddd;">
        <p class="Home-text" (click)="Loguot()" style="margin-top: 10px;">Logout
        </p>

      </div>

    </div>
  </div>
</nz-drawer>

<nz-drawer [nzVisible]="isLoactionVisible" [nzMaskClosable]="false" [nzWidth]="370"
  [nzClosable]="isuserLoged?true:false" [nzPlacement]="'left'" (nzOnClose)="Locationclose()" class="mobileView"
  [nzTitle]="Locatintitle" [nzFooter]="footerTpl">
  <ng-template #Locatintitle>
    <p class="Home-text" style="color: #fff;font-size: 18px;padding: 20px 0px 0px;">Choose your Location</p>
  </ng-template>
  <div nz-row>
    <div nz-col [nzXs]="{ span: 24}" [nzSm]="{ span: 24}" [nzMd]="{ span: 24}" [nzLg]="{ span: 24}">
      <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton1">
        <input type="text" nz-input placeholder="Enter PIN Code" [formControl]="pinCode"
          oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" />
      </nz-input-group>
      <ng-template #suffixButton1>
        <button nz-button nzType="primary" class="Check-button" nzSize="large" nzSearch
          (click)="checkPincode(1)">Check</button>
      </ng-template>
    </div>
  </div>
  <div nz-row style="margin-top: 40px;position: fixed;
  bottom: 70px;" class="mobileView" *ngIf="isuserLoged">
    <div nz-col [nzXs]="{ span: 24}" [nzSm]="{ span: 24}" [nzMd]="{ span: 24}" [nzLg]="{ span: 24}">
      <p class="Saved-Address">Saved Address</p>
    </div>
    <div nz-col [nzXs]="{ span: 24}" [nzSm]="{ span: 24}" [nzMd]="{ span: 24}" [nzLg]="{ span: 24}">
      <div class="cat-list">
        <div class="container-view">
          <ul class="categories">
            <li *ngFor="let item of addressList">
              <div style="
                      position: relative;
              top: -1px;
              width: 280px;
              padding: 0px 15px 0px 0px;">
                <div class="address-box" (click)="onselectedAddress(item)">
                  <span class="banner-tag"><span *ngIf="item.Address_Type==1">Home</span>
                    <span *ngIf="item.Address_Type==2">Work</span>
                    <span *ngIf="item.Address_Type==3">Other</span></span>
                  <p style="color: #0d0c0c;line-height: 1.21;font-size: 14px;">{{item?.Name}}</p>
                  <p style=" color: #949494;line-height: 1.8;font-size: 13px;">{{item?.Address}}
                    <br />{{item.Landmark}} - {{item.PinCode}},
                  </p>
                </div>

              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <ng-template #footerTpl>
    <span class="Current-Location" *ngIf="isuserLoged">
      <img src="/assets/images/add-circle.png" style="width: 8%;" /> <span style="font-size: 18px;margin-left: 15px;"
        (click)="onSelect()">Add New address</span></span>
  </ng-template>
</nz-drawer>

<!-- <div class="WebView">
<nz-modal [(nzVisible)]="isWebLoginVisible" [nzWidth]="550" [nzMaskClosable]="false" [nzFooter]="null" [nzTitle]="''"
  (nzOnCancel)="webLoginCancel()">
<app-login></app-login>
</nz-modal>
</div> -->